import { grantsLeft, grantsRight, missionText } from "@/mocks/home";
import { useReveal } from "@/hooks/useReveal";

function GrantList({ items }: { items: { label: string; href: string }[] }) {
  return (
    <ul className="space-y-3.5">
      {items.map((item) => (
        <li key={item.label} className="flex items-start gap-2.5">
          <i className="ri-leaf-line text-accent-500 mt-0.5 shrink-0" aria-hidden="true" />
          <a
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm md:text-[15px] text-foreground-700 hover:text-primary-600 transition-colors leading-relaxed"
          >
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default function Mission() {
  const { ref, visible } = useReveal<HTMLDivElement>();

  return (
    <section id="our-mission" className="w-full bg-background-100 py-20 md:py-28">
      <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} w-full px-4 md:px-8`}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-[11px] uppercase tracking-[0.32em] text-accent-600">About the Club</p>
            <h2 className="mt-4 font-heading font-light text-3xl md:text-5xl text-foreground-950">Our Mission</h2>
            <p className="mt-7 text-base md:text-lg leading-relaxed text-foreground-700 italic">{missionText}</p>
          </div>

          <div className="mt-16 md:mt-20 rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-10">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-hand-heart-line text-lg" aria-hidden="true" />
              </span>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-950">Grants &amp; Donations 2025&ndash;2026</h3>
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-2">
              <GrantList items={grantsLeft} />
              <GrantList items={grantsRight} />
            </div>
            <p className="mt-8 pt-6 border-t border-background-200/70 text-sm text-foreground-600">
              Read how HGC partnered with POST to provide the{" "}
              <a
                href="https://www.openspacetrust.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 underline underline-offset-4 hover:text-primary-700"
              >
                newest public beach in San Gregorio.
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}